import { useEffect } from "react";


declare global {
    interface Window {
      trackingFunctions?: {
        onLoad: (config: { appId: string }) => void;
      };
    }
}
  

const ApolloTracker = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const randomString = Math.random().toString(36).substring(7);

    script.src = `https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=${randomString}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      if (window.trackingFunctions) {
        window.trackingFunctions.onLoad({ appId: "66428aca4f5271057748b6e2" });
      }
    };

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default ApolloTracker;
